import { useQuery } from '@tanstack/react-query';
import {
  STUDENT_MESSAGING_REFRESH_MS,
  studentMessagingApi,
  studentMessagingKeys,
} from '../api/studentMessaging';
import { useAuthStore } from '../store/auth';

/**
 * Liste des échanges avec les élèves, rafraîchie périodiquement. Partagée par
 * l'écran et par le compteur de non-lus de la navigation : une seule requête.
 */
export function useStudentConversations() {
  const userId = useAuthStore((s) => s.user?.id);
  return useQuery({
    queryKey: studentMessagingKeys.conversations(userId),
    queryFn: studentMessagingApi.getConversations,
    refetchInterval: STUDENT_MESSAGING_REFRESH_MS,
    refetchOnWindowFocus: true,
    staleTime: 0,
    retry: false,
    gcTime: 0,
  });
}

/** Total des messages d'élèves non lus, pour la navigation. */
export function useStudentUnreadCount(): number {
  const { data } = useStudentConversations();
  return (data ?? []).reduce((total, c) => total + (c.unread || 0), 0);
}
